import MessagesPage from "../pages/messages";
import DidsPage from "../pages/Admin/Dids";
import PageNotFound from "../pages/404";
import SendBulkMessagePage from "../pages/BulkMessages";
import RingotelOrgPage from "../pages/Admin/RingotelOrg";
import RingotelUsersPage from "../pages/Admin/RingotelUsers";
import ScheduledMessagesList from "../pages/ScheduledMessage";
import IntegrationsPage from "../pages/Integrations";
import WebhookIntegration from "../pages/Integrations/WebhookIntegration";
import { Templates } from "../pages/Templates/Templates";
import ReportsPage from "../pages/Reports";
import Configurations from "../pages/Settings/Configurations";
import { Scope } from "../utils/permissions";

const coreRoutes = [
  {
    path: "/",
    title: "Message",
    component: MessagesPage,
    permissions: { type: "sms", permissions: ["readMessages:any", "readMessages:account", "readMessages:own"], permission2: "sms.messages.view", permissionScope: "own" as Scope },
  },
  {
    path: "/bulk/send",
    title: "Bulk",
    component: SendBulkMessagePage,
    permissions: { type: "sms", permissions: ["sendBulkSms:any", "sendBulkSms:account", "sendBulkSms:own"], permission2: "sms.bulk_messages.send", permissionScope: "own" as Scope },
  },
  {
    path: "scheduled-messages",
    title: "Scheduled",
    component: ScheduledMessagesList,
    permissions: { type: "sms", permissions: ["readScheduledMessages:any", "readScheduledMessages:account", "readScheduledMessages:own"], permission2: "sms.scheduled_messages.view", permissionScope: "own" as Scope },
  },
  {
    path: "/templates",
    title: "Templates",
    component: Templates,
    permissions: {
      type: "sms", permissions: ["readTemplates:any", "readTemplates:account", "readTemplates:own"], permission2: "sms.templates.view", permissionScope: "own" as Scope
    },
  },
  {
    path: "/numbers",
    title: "Numbers",
    component: DidsPage,
    permissions: { type: "sms", permissions: ["readDids:any", "readDids:account"], permission2: "sms.dids.view", permissionScope: "account" as Scope },
  },
  {
    path: "/ringotel-orgs",
    title: "Ringotel Organizations",
    component: RingotelOrgPage,
    permissions: { type: "sms", permissions: ["readDids:any"], permission2: "sms.dids.view", permissionScope: "system" as Scope },
  },
  {
    path: "/ringotel-users",
    title: "Ringotel Users",
    component: RingotelUsersPage,
    permissions: { type: "users", permissions: ["read:any"], permission2: "users.view", permissionScope: "system" as Scope },
  },
  {
    path: "/integrations",
    title: "Integrations",
    component: IntegrationsPage,
    permissions: { type: "users", permissions: ["read:any"], permission2: "users.view", permissionScope: "system" as Scope },
  },
  {
    path: "/webhooks",
    title: "SMS Webhooks",
    component: WebhookIntegration,
    permissions: { type: "sms", permissions: [], permission2: "sms.webhooks.view", permissionScope: "account" as Scope },
  },
  {
    path: "/reports",
    title: "Reports",
    component: ReportsPage,
    permissions: { type: "sms", permissions: ["readMessages:any", "readMessages:account", "readMessages:own"], permission2: "reports.sms.view", permissionScope: "own" as Scope },
  },
  {
    path: "/configurations",
    title: "Configurations",
    component: Configurations,
    permissions: { type: "sms", permissions: ["readUserConfigurations:any", "readUserConfigurations:account", "readUserConfigurations:own"], permission2: "sms.configurations.view.user", permissionScope: "own" as Scope }
  },
  {
    path: "*",
    title: "Page Not Found",
    component: PageNotFound,
  },
];

const routes = [...coreRoutes];
export { routes };
